import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { withSize, Truncate } from '@bd/bdcore-utilities';
import { get } from 'lodash';

import AccordionToggle from '../../components/AccordionToggle';
import { typography, colors } from '../../styles';
import { UnderdogLeftAlt } from '../../helpers/UIElements';

const styles = css`
  @media(min-width: 992px) {
    padding: 0 0 50px;
    position: relative;
  }
  .CommunityWelcome_scrollTarget {
    @media(min-width: 768px) {
      padding: 50px 0;
      position: absolute;
      top: -50px;
      left: 0;
    }
  }
  .CommunityWelcome_description, .CommunityWelcome_description p {
    font-weight: 300;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    line-height: 24px;
    @media(min-width: 992px) {
      font-size: 20px;
      line-height: 36px;
      padding-right: 80px;
    }
  }
  .DetailSection_heading {
    @media(min-width: 992px) {
      font-family: ${typography.Serif};
      font-size: 66px;
      color: #181818;
      letter-spacing: 0;
      text-align: left;
      text-transform: capitalize;
      span {
        font-family: ${typography.SansSerif};
        text-transform: uppercase;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: #4B4B4B;
        letter-spacing: 4px;
        text-align: left;
        margin: 25px 0 0;
      }
    }
  }
  .btn-link {
    display: inline-block;
    font-weight: 700;
    font-size: 16px;
    color: #181818;
    letter-spacing: 0;
    line-height: 24px;
    text-transform: capitalize;
    background-color: #FFF;
    padding: 0;
    @media(min-width: 992px) {
      font-size: 20px;
      line-height: 36px;
    }
    &:hover {
    text-decoration: none;
    color: ${colors.color1};
    }
  }
  .CommunityWelcome_title {
    @media(min-width: 992px) {
      font-family: ${typography.Serif};
      font-size: 28px;
      line-height: 1.8em;
      color: #181818;
      letter-spacing: 4px;
      text-align: left;
      text-transform: uppercase;
      span {
        font-family: ${typography.SansSerif};
        text-transform: uppercase;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        color: #4B4B4B;
        letter-spacing: 4px;
        text-align: left;
        margin: -5px 0 0;
      }
    }
  }

  .CommunityWelcome_container-truncated {
    @media(min-width: 992px) {
      overflow: hidden;
    }
  }
`;

class CommunityWelcome extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      readMore: false,
    };
  }

  readMore = value => () => {
    this.setState({
      readMore: value,
    });
  }

  render() {
    const { community, size } = this.props;
    const { readMore } = this.state;
    const customDescripton = get(community, 'custom_description', get(community, 'description'));
    return (
      <div className={styles}>
        <div id="welcome" className="CommunityWelcome_scrollTarget" />
        <AccordionToggle
          openOnId="welcome"
          button={({ contentVisible }) => (
            <div className="DetailsSection_btn d-lg-none" role="button" tabIndex={0}>
              <h3 className={`DetailSection_heading ${contentVisible && 'DetailSection_heading-open'}`}>Welcome <span>to {get(community, 'name')}</span></h3>
            </div>
          )}
        >
          <div className={`${size.width < 992 ? 'container' : ''} ${readMore ? '' : 'CommunityWelcome_container-truncated'}`}>
            <UnderdogLeftAlt className="d-none d-lg-block">
              <h3 className="CommunityWelcome_title d-none d-lg-flex flex-column">Welcome <span>to {get(community, 'name')}</span></h3>
            </UnderdogLeftAlt>
            {
              customDescripton &&
              <div className="CommunityWelcome_description d-lg-block py-lg-0 py-sm-3">
                <Truncate
                  nl2br
                  words={100}
                  value={customDescripton}
                  buttonClass="btn btn-link"
                  button="Read More"
                />
              </div>
            }
          </div>
        </AccordionToggle>
      </div>
    );
  }
}

CommunityWelcome.propTypes = {
  community: PropTypes.object.isRequired,
  size: PropTypes.object.isRequired,
};

export default withSize()(CommunityWelcome);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/CommunityWelcome.js